export default __webpack_public_path__ + "028fb66554406570bc1a612956e0bd52.svg";